export default __webpack_public_path__ + "static/media/650.8e397695.png";